import { render } from "./Hero.vue?vue&type=template&id=37a74853"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"
script.render = render

export default script